/**
 * As quatro abas de Docs/04-Design/Navegação.md — rota, rótulo e a CHAVE do
 * ícone, sem componente.
 *
 * A chave, e não o componente: este arquivo não pode exportar componente
 * nenhum (ver abaixo), e quem resolve a chave é o `TabBar`.
 *
 * Em módulo próprio, não em TabBar.tsx: react-refresh/only-export-components
 * exige que um arquivo que exporta um componente não exporte mais nada além
 * dele, senão o Fast Refresh do `pnpm dev` para de funcionar naquele arquivo.
 */
export const TABS = [
  { to: '/', label: 'Dashboard', icone: 'casa' },
  { to: '/transacoes', label: 'Transações', icone: 'fluxo' },
  { to: '/produtos', label: 'Produtos', icone: 'etiqueta' },
  { to: '/lembretes', label: 'Lembretes', icone: 'lista' },
] as const
